import type { ConversationNodeAnnouncement } from 'lib-shared-types-api';

type RoutedThroughAnnouncementProps = {
  node: ConversationNodeAnnouncement;
};

export function RoutedThroughAnnouncement({
  node,
}: RoutedThroughAnnouncementProps): JSX.Element {
  return (
    <>
      Audio message · <strong>{node.label}</strong> is played
    </>
  );
}
